export default __webpack_public_path__ + "src/images/packages/oceana-reserve/10a743f87d4d2b4c793cf4ef2a72ceb0-1.jpg";